import Call from '../Call';

const Servers = {
    get(type) {
        return Call(`servers/${type}`);
    },

    save(server) {
        return Call('servers','POST', server);
    },

    remove(id) {
        return Call(`servers/${id}`,'DELETE');
    },
};

export default Servers;


// WEBPACK FOOTER //
// ./src/services/API/components/Servers.js